import { render } from "./AdvertiserAccountCreator.vue?vue&type=template&id=68c8b21c"
import script from "./AdvertiserAccountCreator.vue?vue&type=script&lang=js"
export * from "./AdvertiserAccountCreator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/51/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__